module.exports = __webpack_public_path__ + "static/img/fl23_3.6d11a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fl20210204/fl23_3.png
// module id = SaCi
// module chunks = 0